import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EnvironmentService } from '@galaxy/core';
import { googleTransferAppId } from '../../../marketplace-app/global-brands-constants';

export interface ActivationMessageDialogData {
  apps: {
    name: string;
    icon: string;
    appId: string;
    type: ActivationMessageSupportedApps;
  }[];
}

export enum ActivationMessageSupportedApps {
  WORKSPACE = 1,
  OFFICE,
}

@Component({
  templateUrl: './activation-message-dialog.html',
  styleUrls: ['./activation-message-dialog.component.scss'],
  standalone: false,
})
export class ActivationMessageDialogComponent implements OnInit {
  hasGoogleTransferApp = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ActivationMessageDialogData,
    public dialogRef: MatDialogRef<ActivationMessageDialogComponent>,
    private environmentService: EnvironmentService,
  ) {}

  ngOnInit(): void {
    const env = this.environmentService.getEnvironment();

    this.data.apps.map((app) => {
      if (app.appId === googleTransferAppId[env]) {
        this.hasGoogleTransferApp = true;
      }
    });
  }

  get activationMessageSupportedApps(): typeof ActivationMessageSupportedApps {
    return ActivationMessageSupportedApps;
  }
}
